import styled from '@emotion/styled';
import {
  ButtonNormalSecondarySmallCompact,
  ButtonWrapper,
  RowCenterBetween,
  TextHeading2,
  token,
} from '@ferreri/prever-component-lib';

import { CategoriesListModal } from '../categories/CategoriesListModal';
import { CategoriesList } from '../categories/CategoriesList';
import { StyledSection } from '@components/layouts/Layouts';
import { useToggle } from '@utils/useToggle';

export const PublicationsCategoriesList = () => {
  const [isOpen, handleToggle] = useToggle();

  return (
    <CategoryFilterSection>
      <StyledSection>
        <RowCenterBetween>
          <TextHeading2>Categorias</TextHeading2>
          <ButtonWrapper onClick={handleToggle}>
            <ButtonNormalSecondarySmallCompact>
              Ver todas
            </ButtonNormalSecondarySmallCompact>
          </ButtonWrapper>
          <CategoriesListModal
            isOpen={isOpen}
            onClose={handleToggle}
            onCloseClick={handleToggle}
          />
        </RowCenterBetween>
      </StyledSection>
      <CategoriesList />
    </CategoryFilterSection>
  );
};

const CategoryFilterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingSmall};
`;
